import React, { useState } from 'react';
import StatsSqlDialog from './StatsSqlDialog';
import { belgianDates } from './dateFormat';

/**
 * Title + short explanation above a table or chart, with an "i" button (SUPER only,
 * when the backend sent the queries) that opens the SQL behind it.
 */
export default function StatsSectionHeader({ label, count, description, sql, showSql, theme, t }) {
  const [open, setOpen] = useState(false);
  const canShow = showSql && sql && sql.length > 0;
  const tr = (k, fallback) => (t ? t(k) : null) || fallback;

  return (
    <div style={{ margin: '0 0 6px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'nowrap' }}>
        {canShow && (
          <button
            type="button"
            onClick={() => setOpen(true)}
            title={tr('stats_show_sql', 'Toon de query')}
            aria-label={tr('stats_show_sql', 'Toon de query')}
            style={{ flex: '0 0 auto', width: 22, height: 22, borderRadius: '50%', border: '1px solid rgba(128,128,128,0.6)', background: 'transparent', color: 'inherit', cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'Georgia, serif', lineHeight: '20px', padding: 0 }}
          >i</button>
        )}
        <h3 className={theme} style={{ margin: 0, width: 'auto', flex: '0 1 auto' }}>
          {belgianDates(label)}
          {typeof count !== 'undefined' && <span style={{ fontWeight: 400, opacity: 0.6, fontSize: 13, marginLeft: 6 }}>({count})</span>}
        </h3>
      </div>
      {description && (
        <p style={{ margin: '4px 0 0', fontSize: 12.5, lineHeight: 1.45, opacity: 0.78, maxWidth: 1100 }}>{description}</p>
      )}
      {canShow && <StatsSqlDialog open={open} onClose={() => setOpen(false)} title={belgianDates(label)} sql={sql} t={t} />}
    </div>
  );
}
